<template>
  <div class="notifications card text-md" id="tpl_reccommendation_popup">
    <div class="cursor-pointer absolute right-5 hover:text-[var(--color-orange)]" id="btn_close">
      <i @click.prevent="deactivate()">
        <font-awesome-icon icon="fa-xmark"/>
      </i>
    </div>
    <div>
      <div class="flex flex-row items-center flex-start gap-2 pb-2">
        <img class="w-12 h-12" src="@/assets/lamp.png" alt="">
        <h3>
          <span id="txt_developmentTipHeader">
            {{ $t('RecommendationNotificationComponent.devTip') }}
          </span>
        </h3>
      </div>
      <div class="break-normal flex">
        <div v-if="notification">
          <span v-html="notification.content?.text[lang] ?? '-'"></span>
        </div>
      </div>
    </div>
    <div class="flex flex-row justify-between items-center gap-3 pt-5">
      <button type="button" class="btn-primary-accent" @click.prevent="markSeen">
        {{ $t('RecommendationNotificationComponent.okay') }}
      </button>
      <button type="button" class="recommendation-popup__feedback-btn" @click.prevent="setFeedbackOverlay">
        {{ $t('RecommendationNotificationComponent.giveFeedback') }} >
      </button>
    </div>
  </div>
  <FeedbackOverlayComponent v-if="showFeedbackDialog" :visible="showFeedbackDialog"
    @update:visible="showFeedbackDialog = $event" :data="notification"
    @confirmed="onFeedbackConfirmed"></FeedbackOverlayComponent>
</template>

<script>
import FeedbackOverlayComponent from '../FrontendOverlays/FeedbackOverlayComponent.vue';

export default {
  props: ['notification'],
  name: 'RecommendationNotificationComponent',
  components: { FeedbackOverlayComponent },
  data() {
    return {
      showFeedbackDialog: false,
    };
  },
  methods: {
    async deactivate() {
      await this.$store.dispatch('deactivatePopUp', this.notification._id);
    },
    async markSeen() {
      const tipId = this.notification.content?.tipId;
      if (tipId) {
        await this.$store.dispatch('devTips/markDevTipAsViewed', tipId);
      }
      await this.$store.dispatch('deactivatePopUp', this.notification._id);
    },
    async setFeedbackOverlay() {
      /* this.$store.commit('addFrontendOverlay', {
        id: Math.random(),
        type: 'feedback',
        notification: this.notification,
      }); */
      this.showFeedbackDialog = true;
    },
    async onFeedbackConfirmed() {
      this.showFeedbackDialog = false;
      await this.deactivate();
    },
  },
  computed: {
    lang() {
      return this.$i18n.locale;
    },
  },
};
</script>

<style scoped>
.recommendation-popup__feedback-btn {
  background: none;
  border: none;
  padding: 0.5rem 0;
  font: inherit;
  color: inherit;
  cursor: pointer;
  transition: color 0.2s;
}

.recommendation-popup__feedback-btn:hover {
  color: var(--color-orange);
}
</style>
